export class AnatomicalSystemContentModel {
    public langId: number;
    public anatomicalSystemName: string;
}